<template>
    <div class="shipping__method__header">
        <span class="shipping__method__header__title">نحوه ارسال</span>
    </div>
    <div class="shipping__address">
        <div class="shipping__address__content">
            <div class="shipping__address__item-wrapper">
                <div class="shipping__address__item">
                    <span class="shipping__address__item__key">این سفارش از طریق </span>
                    <span class="shipping__address__item__value"> {{shipping_method.title}} </span>
                    <template v-if="shipping_method.periods?.length">
                        <span class="shipping__address__item__key"> در </span>
                        <span class="shipping__address__item__value"> {{shipping_method.periods[0][0].date_beautiful}} </span>
                        <span class="shipping__address__item__key"> در بازه </span>
                        <span class="shipping__address__item__value">
                                {{shipping_method.periods[0][0].start_hour}}&nbsp;تا&nbsp;{{shipping_method.periods[0][0].end_hour}}
                            </span>
                    </template>
                    <span class="shipping__address__item__key"> به </span>
                    <span class="shipping__address__item__value"> {{address.name}} </span>
                    <span class="shipping__address__item__key"> به آدرس </span>
                    <span class="shipping__address__item__value"> {{address.province.name}}، {{address.city.name}}، {{address.line}} </span>
                    <span class="shipping__address__item__key"> ارسال خواهد شد. </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ShippingSummary",
    props: ['address', 'shipping_method'],
}
</script>

<style scoped>

</style>
